/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import {DatePeriodType} from '@ion/core/src/types/services';
import {DateSelectorValues} from '@ion/dls/src/types/types';
import {PageInitializeAction} from '@/types/redux';

// defines the valid dashboard tab indices ...
export enum DashboardTab {
  DEVICES = 0,
  SAFETY = 1,
  UTILIZATION = 2,
  DRIVER = 3,
  SAFETY_BASIC = 4
};

export enum DriverDashboardTab {
  EVENTS = 0,
  SAFETY_SCORES = 1
};

// defines the type definitions for dashboard period ...
export type DashboardPeriod = {
  period: DatePeriodType;
  filter: DateSelectorValues;
};

export interface DriverDashboardAssetFilter {
  label: string;
  value: any;
  id?: number;
};

export interface DriverDashboardFilters {
  startDate: string | null;
  endDate: string | null;
  assets: DriverDashboardAssetFilter[];
};

// defines the widget key for each widget in dashboard
export enum WidgetKey {
  DeviceCommunication = 'deviceCommunication',
  MissingAssociationWidgets = 'missingAssociationWidgets',
  DriverScorecard = 'driverScorecard'
};

// defines the default widget list for dashboard...
export const defaultWidgetList = {
  device : [
    WidgetKey.DeviceCommunication,
    WidgetKey.MissingAssociationWidgets
  ]
};

// initialize dashboard ...
export const INITIALIZE_DASHBOARD          = 'INITIALIZE_DASHBOARD';

// dashboard tab change ...
export const SET_SELECTED_DASHBOARD_TAB    = 'SET_SELECTED_DASHBOARD_TAB';

// edit dashboard
export const SET_ADDED_WIDGETS             = 'SET_ADDED_WIDGETS';
export const SET_SHOW_EDIT_WIDGETS         = 'SET_SHOW_EDIT_WIDGETS';

// Sisense dashboard edit
export const SET_SISENSE_IFRAME_WIDGET     = 'SET_SISENSE_IFRAME_WIDGET';
export const SET_SISENSE_SDK_WIDGET        = 'SET_SISENSE_SDK_WIDGET';
export const SET_DRIVER_DASHBOARD_FILTERS  = 'SET_DRIVER_DASHBOARD_FILTERS';
export const SET_DRIVER_DASHBOARD_SELECTED_TAB = 'SET_DRIVER_DASHBOARD_SELECTED_TAB';

/**
 * Initialize Dashboard
 */
export const initializeDashboard = (): PageInitializeAction => {
  return {type: INITIALIZE_DASHBOARD};
};

/**
 * Invoked when the selected dashboard tab changes.
 */
export const setSelectedTab = (selectedTab: DashboardTab) => ({
  type : SET_SELECTED_DASHBOARD_TAB, selectedTab
});

// invoke whenever changes happen in edit dashboard...
export const setAddedWidgets = (widgetList) => ({
  type : SET_ADDED_WIDGETS, widgetList
});

// invoke on change of sisense iframe edit dashboard...
export const setIFrameWidget = (widgetList) => ({
  type : SET_SISENSE_IFRAME_WIDGET, widgetList
});

// invoke on change of sisense SDK edit dashboard...
export const setSDKWidget = (widgetList) => ({
  type : SET_SISENSE_SDK_WIDGET, widgetList
});

// invoke when driver dashboard filters need to be persisted for the session...
export const setDriverDashboardFilters = (filters: DriverDashboardFilters) => ({
  type : SET_DRIVER_DASHBOARD_FILTERS, filters
});

// invoke when the selected driver dashboard tab changes...
export const setDriverDashboardSelectedTab = (selectedTab: DriverDashboardTab) => ({
  type : SET_DRIVER_DASHBOARD_SELECTED_TAB, selectedTab
});

// invoke when edit modal needs to be shown or hidded
export const setShowEdit = () => {
  return async(dispatch, getState) => {
    const {showEdit} = getState().dashboard;
    dispatch({type: SET_SHOW_EDIT_WIDGETS, showEdit});
  };
};
